export const LOGIN = "v2/auth/login";
export const FORGOT_PASSWORD = "v2/auth/forgot-password";
export const NEW_PASSWORD = "v2/auth/new-password";
export const POLICY_TERMS = "v2/auth/policy-terms";
export const CHANGE_PASSWORD = "v2/auth/change-password";
export const CHANGE_PROFILE_PICTURE = "v2/auth/profile-picture";
export const GET_PROFILE_PICTURE = "v2/auth/profile-picture";